import React from 'react'
import './_BentoRadio.scss'

const BentoRadio = ({ name, checked, onChange, children, className }) => {
  return (
    <label className={`bento-radio w-100p bento-radio__secondary ${className}`}>
      <div className="flex flex-start p-relative flex-middle">
        <input
          type="radio"
          className="bento-radio__input"
          name={name}
          checked={checked}
          onChange={onChange}
        />
        <span
          className="bento-radio__circle bento-radio__border"
          style={{ width: '16px', height: '16px' }}
        />
      </div>
      {children}
    </label>
  )
}

export default BentoRadio
